/*
 * Hero page-load sequence (ported from OSO Supreme v1's scroll-reveal.js):
 * the first slideshow's title words light up left to right (0.18 → 1), then
 * the description, then the buttons rise in.
 *
 * Standalone so the homepage's own scroll-reveal.js (which drives the other
 * sections) is untouched. Hidden states are keyed on `.hero-seq`, which only
 * this script adds, so without JS or under reduced motion the hero renders as-is.
 */
(function () {
  if (!document.documentElement.classList.contains('scroll-reveal-on')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function wrapWords(node, className) {
    if (node.nodeType === 3) {
      var parts = node.nodeValue.split(/(\s+)/);
      if (parts.length === 1 && !parts[0].trim()) return;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < parts.length; i++) {
        var t = parts[i];
        if (!t) continue;
        if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); continue; }
        var span = document.createElement('span');
        span.className = className;
        span.textContent = t;
        frag.appendChild(span);
      }
      node.parentNode.replaceChild(frag, node);
    } else if (node.nodeType === 1 && node.tagName !== 'BR') {
      var kids = Array.prototype.slice.call(node.childNodes);
      for (var k = 0; k < kids.length; k++) wrapWords(kids[k], className);
    }
  }

  function heroSequence() {
    var first = document.querySelector('.slideshow-media');
    if (!first) return;
    var section = first.closest('.shopify-section');
    if (!section || section.dataset.heroBound) return;
    section.dataset.heroBound = '1';
    // All slides in the section, including Swiper loop clones.
    var slides = section.querySelectorAll('.slideshow-media');
    for (var s = 0; s < slides.length; s++) {
      var slide = slides[s];
      var title = slide.querySelector('.slideshow-title');
      if (!title) continue;
      if (!title.querySelector('.hero-word')) wrapWords(title, 'hero-word');
      var words = title.querySelectorAll('.hero-word');
      for (var i = 0; i < words.length; i++) words[i].style.setProperty('--hero-i', i);
      slide.style.setProperty('--hero-words', words.length);
      slide.classList.add('hero-seq');
    }
    // Two frames so the dim starting styles paint before the transitions begin.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { section.classList.add('hero-seq-go'); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heroSequence);
  else heroSequence();
})();
